import StoreModule from "./store_module";
import TFMService from "@/api/service";
import _ from "lodash";
import Vue from "vue";
import Features from "@/common/feature-lib";

const name = "total_station";

const mutations = {
	CLEAR_FILTER(state) {
		state.filter = "";
	},

	SET_FILTER(state, filter) {
		state.filter = filter;
	},

	SET_EMPTY_TS_FILTER(state, setTSEmpty) {
		state.setTSEmpty = setTSEmpty;
	},

	SET_USERCLIENTACCESS(state, data) {
		state.userClientAccess = data;
	},

	SET_SELECTED_DEVICE_TYPE_IDS(state, deviceTypeIds) {
		if (_.isArray(deviceTypeIds)) {
			state.selectedDeviceTypeIds = deviceTypeIds;
			return;
		}

		state.selectedDeviceTypeIds = [deviceTypeIds];
	},

	SET_EXCLUDED_DEVICE_TYPE_IDS(state, deviceTypeIds) {
		if (_.isArray(deviceTypeIds)) {
			state.unselectedDeviceTypeIds = deviceTypeIds;
			return;
		}
		state.unselectedDeviceTypeIds = [deviceTypeIds];
	},

	SET_SELECTED_DEVICE_STATUS_IDS(state, deviceStatusIds) {
		if (_.isArray(deviceStatusIds)) {
			state.selectedDeviceStatusIds = deviceStatusIds;
			return;
		}
		state.selectedDeviceStatusIds = [deviceStatusIds];
	},
	SET_SELECTED_DEVICE_OPERATOR_ID(state, Id) {
		if (_.isArray(Id)) {
			state.selectedDeviceOperatorId = Id;
			return;
		}
		state.selectedDeviceOperatorId = Id;
	},
	SET_SELECTED_DEVICE_PROJECT_ID(state, Id) {
		if (_.isArray(Id)) {
			state.selectedDeviceProjectId = Id;
			return;
		}
		state.selectedDeviceProjectId = Id;
	},
	SET_SELECTED_DEVICE_OWNER_ID(state, Id) {
		if (_.isArray(Id)) {
			state.selectedDeviceOwnerId = Id;
			return;
		}
		state.selectedDeviceOwnerId = Id;
	},

	ADD(state, { id, data }) {
		Vue.set(state.entries, id, data);
	},

	ADD_SET(state, payload) {
		_.each(payload, (v, k) => {
			Vue.set(state.entries, k, v);
		});
	},

	SET_MANAGE_INFO(state, { id, data }) {
		Vue.set(state.manageInfo, id, data);
	},

	DESELECT(state) {
		state.selected = null;
	},

	SELECT(state, id) {
		if (id == state.selected) id = null;
		state.selected = id;
	},

	CLEAR(state) {
		state.entries = {};
	},

	DELETE(state, { id }) {
		Vue.delete(state.entries, id);
	},

	UPDATE(state, { id, data }) {
		Vue.set(state.entries, id, Object.assign(state.entries[id], data));
	}
};

const actions = {
	async FETCH_ALL(context) {
		const ts = await TFMService.getTotalStations();
		context.commit("ADD_SET", ts);
		return ts;
	},
	async FETCH_USERCLIENTACCESS(context) {
		const data = await TFMService.fetchClientsByUser();
		context.commit("SET_USERCLIENTACCESS", data);
	},
	async FETCH_TOTAL_STATION_MANAGE_INFO(context, { id }) {
		const data = await TFMService.getTotalStationManageInfo(id);
		context.commit("SET_MANAGE_INFO", { id, data });
	}
};

const getters = {
	selected: state =>
		state.selected && state.entries[state.selected]
			? state.entries[state.selected]
			: null,

	allEntries: state => state.entries,

	filteredEntries: (state, getters, globalState, globalGetters) => {
		// Filter by text search
		let filteredTotalStations = _.filter(
			state.entries,
			ts =>
				(ts.totalStationId + " " + ts.description + " " + ts.locationDesc)
					.toLowerCase()
					.indexOf(state.filter.toLowerCase()) > -1
		);
		const isProjectIdSelected = (state, ts) => {
			return (
				_.filter(ts.devices, device => {
					return device.projectId == state.selectedDeviceProjectId;
				}).length > 0
			);
		};
		const isOperatorSelected = (state, ts) => {
			return (
				_.filter(ts.devices, device => {
					return device.operatorId == state.selectedDeviceOperatorId;
				}).length > 0
			);
		};
		const isOwnerSelected = (state, ts) => {
			return (
				_.filter(ts.devices, device => {
					return device.ownerId == state.selectedDeviceOwnerId;
				}).length > 0
			);
		};

		// Filter by operator id
		if (state.selectedDeviceOperatorId != 0) {
			filteredTotalStations = _.filter(
				filteredTotalStations,
				ts =>
					ts.totalStationOperatorId == state.selectedDeviceOperatorId ||
					isOperatorSelected(state, ts)
			);
		}
		// Filter by owner id
		if (state.selectedDeviceOwnerId != 0) {
			filteredTotalStations = _.filter(
				filteredTotalStations,
				ts =>
					ts.totalStationOwnerId == state.selectedDeviceOwnerId ||
					isOwnerSelected(state, ts)
			);
		}

		// This is the end of the original filtering if TOTALSTATION feature
		// is not available.
		if (!globalGetters.currentUserHasFeature(Features.FEATURE_TOTALSTATION)) {
			return filteredTotalStations;
		}

		let selectedDevices;
		const getFilteredDevicesForTotalStation = (state, totalStation) => {
			selectedDevices = _.filter(totalStation.devices, device => {
				return isDeviceSelected(state, device);
			});
			if (selectedDevices.length > 0) return true;
			return false;
		};

		const isUnSelectedDeviceType = (state, totalStation) => {
			// Filter TS with excluded heckedc
			let arr = _.filter(totalStation.devices, device => {
				return state.unselectedDeviceTypeIds.indexOf(device.deviceTypeId) > -1;
			});
			if (arr.length > 0) {
				return false; //Total Station consists of exluded device type
			} else {
				//Filter out Required device type
				if (state.selectedDeviceTypeIds.length > 0) {
					_.forEach(state.selectedDeviceTypeIds, function(e) {
						arr = _.filter(totalStation.devices, device => {
							if (device.deviceTypeId == e)
								return isDeviceSelected(state, device);
						});
						if (arr.length == 0) return false;
					});
					return arr.length > 0 ? true : false;
				} else return true;
			}
		};

		const isDeviceSelected = (state, device) => {
			const isSelectedDeviceStatus =
				state.selectedDeviceStatusIds.indexOf(device.deviceStatusId) > -1;
			return isSelectedDeviceStatus;
		};
		// Filter further by device type & device status
		filteredTotalStations = _.filter(filteredTotalStations, totalStation => {
			if (
				state.setTSEmpty &&
				(!totalStation.devices || totalStation.deviceCount === 0)
			) {
				return true;
			}
			if (getFilteredDevicesForTotalStation(state, totalStation)) {
				return isUnSelectedDeviceType(state, totalStation);
			} else return false;
		});

		// Filter by project id if inserted by user
		if (state.selectedDeviceProjectId && state.selectedDeviceProjectId.length) {
			filteredTotalStations = _.filter(filteredTotalStations, totalStation => {
				return isProjectIdSelected(state, totalStation);
			});
		}

		return filteredTotalStations;
	},

	filter: state => state.filter,
	setTSEmpty: state => state.setTSEmpty,

	devicesById: (state, getters) => id => {
		const entry = getters.byIdentifier(id);
		if (entry && "devices" in entry) return entry.devices;
		return null;
	},

	numDevicesById: (state, getters) => id => {
		const devices = getters.devicesById(id);
		if (!devices) return 0;
		return Object.keys(devices).length;
	},

	numFunctionalDevicesById: (state, getters) => id => {
		const devices = getters.devicesById(id);
		if (!devices) return 0;
		return _.countBy(devices, "isDeployed").true || 0;
	},

	isAllFunctionalById: (state, getters) => id => {
		return getters.numFunctionalDevicesById(id) == getters.numDevicesById(id);
	},

	// functionalIcon: (state, getters) => id => {
	// 	const entry = getters.byIdentifier(id);
	// 	if (entry && "devices" in entry) return entry.functionalIcon;
	// 	return null;
	// },

	byIdentifier: state => id => state.entries[id],

	selectedDeviceTypeIds: state => state.selectedDeviceTypeIds,
	unselectedDeviceTypeIds: state => state.unselectedDeviceTypeIds,

	selectedDeviceStatusIds: state => state.selectedDeviceStatusIds,
	selectedDeviceOwnerId: state => state.selectedDeviceOwnerId,
	selectedDeviceOperatorId: state => state.selectedDeviceOperatorId,
	selectedDeviceProjectId: state => state.selectedDeviceProjectId,

	manageInfoByID: state => id => state.manageInfo[id],

	userClientAccess: state => state.userClientAccess
};

const initialState = {
	entries: {},
	filter: "",
	setTSEmpty: false,
	selected: null,
	cool: "yes",
	selectedDeviceTypeIds: [],
	unselectedDeviceTypeIds: [],
	selectedDeviceStatusIds: [],
	selectedDeviceOperatorId: [],
	selectedDeviceProjectId: [],
	selectedDeviceOwnerId: [],
	userClientAccess: [],
	manageInfo: {}
};

const totalStationModule = new StoreModule(
	name,
	mutations,
	actions,
	getters,
	initialState
);

export default totalStationModule;
